<template>
    <div class="container-fluid bg-white p-4 rounded">
        <div class="row p-3">
            <div class="col-md-12 mb-3">
                <router-link to="/admin/witness" class="back-link btn btn-success">
                    <font-awesome-icon icon="backward" class="text-white back-icon"/>
                </router-link>
            </div>

            <div class="col-md-12">
                <h4 class="text-center fw-bold bg-body-secondary p-3 rounded" style="font-family: 'Felix Titling'">Add
                    Witness</h4>
            </div>
            <div class="col-md-8 m-auto">
                <b-form @submit.prevent="witnessSearch" class="input-group">
                    <input
                            type="text"
                            class="form-control search-input"
                            v-model="search"
                            placeholder="Search this email">
                    <div class="input-group-append">
                        <button
                                class="btn btn-secondary"
                                type="submit">
                            <font-awesome-icon icon="search"/>
                        </button>
                    </div>
                </b-form>
            </div>

            <div class="col-md-10 m-auto mt-4 witness1 rounded" v-if="searchData.name !== null">
                <div class="card mb-2">
                    <div><img src="@/assets/images/profile.jpg" alt="" class="rounded-circle border-primary me-3"
                              height="50"
                              width="50">{{ searchData.name }}
                    </div>
                    <div class="details text-secondary">
                        <font-awesome-icon icon="eye" style="margin-left: 60px; gap: 20px" class="text-secondary"/>
                        <span @click="openModal">View Details</span>
                    </div>
                </div>
            </div>
            <b-modal v-model="isModalVisible" :title="searchData.name" size="md" class="custom-modal"
                     id="details-modal">
                <div class="modal-body">

                    <div class="modal-item">
                        <font-awesome-icon icon="users" class="modal-icon"/>
                        <h5>Relation: <span class="modal-value">{{ searchData.relation || 'N/A' }}</span></h5>
                    </div>
                    <div class="modal-item">
                        <font-awesome-icon icon="envelope" class="modal-icon"/>
                        <h5>Email: <span class="modal-value">{{ searchData.email || 'N/A' }}</span></h5>
                    </div>
                    <div class="modal-item">
                        <font-awesome-icon icon="user-friends" class="modal-icon"/>
                        <h5>Father Name: <span class="modal-value">{{ searchData.fatherName || 'N/A' }}</span></h5>
                    </div>
                    <div class="modal-item">
                        <font-awesome-icon icon="phone" class="modal-icon"/>
                        <h5>Mobile: <span class="modal-value">{{ searchData.mobile || 'N/A' }}</span></h5>
                    </div>
                    <div class="modal-item">
                        <font-awesome-icon icon="heart" class="modal-icon"/>
                        <h5>Marital Status: <span class="modal-value">{{ searchData.maritalStatus || 'N/A' }}</span>
                        </h5>
                    </div>
                    <div class="modal-item">
                        <font-awesome-icon icon="briefcase" class="modal-icon"/>
                        <h5>Profession: <span class="modal-value">{{ searchData.profession || 'N/A' }}</span></h5>
                    </div>
                    <div class="modal-item">
                        <font-awesome-icon icon="calendar" class="modal-icon"/>
                        <h5>Date: <span class="modal-value">{{ searchData.wnDate || 'N/A' }}</span></h5>
                    </div>
                    <div class="assign-witness">
                        <a @click="assignWitness(searchData.email)" class="btn btn-success">Assign Witness</a>
                    </div>
                </div>

                <template #modal-footer>
                    <b-button variant="outline-danger" @click="isModalVisible = false" class="close-btn">Close
                    </b-button>
                </template>
            </b-modal>
            <div class="col-md-12 mt-4 text-center">
                <router-link to="outside-witness" class="btn btn-outline-success "> Add Outside Witness [+]
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import apiRepository from "@/services/ApiRepository";
    import {toast} from "vue3-toastify";

    export default {
        name: 'CreateWitness',
        data() {
            return {
                search: null,
                witnessAllData: [],
                searchData: {
                    email: null,
                    fatherName: null,
                    maritalStatus: null,
                    mobile: null,
                    motherName: null,
                    name: null,
                    profession: null,
                    relation: null,
                    wnDate: null,
                },
                isModalVisible: false,
            }
        },
        components: {},
        mounted() {
            this.getWitnessData();
        },
        methods: {
            openModal() {
                this.isModalVisible = true; // Show the modal
            },
            closeModal() {
                this.isModalVisible = false; // Hide the modal
            },
            assignWitness(data) {
                try {
                    apiRepository.assignWitnessData(data).then((res) => {
                        if (res) {
                            toast.success('Witness Assign Successfully.')
                        } else {
                            toast.error('Data Not Found!')
                        }
                    }).catch((error) => {
                        toast.error(error.response?.data)
                    })
                } catch (error) {
                    toast.error(error)
                }
            },
            getWitnessData() {
                // apiRepository.getWitness().then(res => {
                //   this.witnessAllData = res.data;
                // })
            },
            witnessSearch() {
                try {
                    apiRepository.searchWitnessNominee(this.search, true).then((response) => {
                        if (response) {
                            this.searchData = response.data
                        } else {
                            toast.error('Data Not Found', response.data)
                        }
                    }).catch(error => {
                        toast.error(error.response?.data || 'Data not found!');
                    })
                } catch (e) {
                    console.error('Unexpected Error: ', e)
                }
            },
        }
    }

</script>

<style scoped>

    /* Modal Background and Animation */
    .search-input {
        position: relative;
        z-index: 1000;
    }


</style>